const axios = require("axios").default;
const APP_API = process.env.BASE_API;
import { COOKIE_KEY } from "@/configs/settings";
import createRepository from "@/repositories/RepositoryFactory";
import Cookies from "js-cookie";
import { v4 as uuidv4 } from "uuid";

export default (function () {
	class httpResources {
		constructor(baseUrl = APP_API) {
			this.user = null;
			this.baseUrl = baseUrl;
			this.axios = null;
			this.repositories = null;
			this.createUser();
			this.init();
		}

		async createUser() {
			let userId = Cookies.get(COOKIE_KEY.USER_ID);
			if (!userId) {
				userId = `lora-embed_${uuidv4()}-${new Date().getTime()}`;
				Cookies.set(COOKIE_KEY.USER_ID, userId);
			}
			this.user = {
				uid: userId,
				userId: 0,
				isGuest: true,
			};
		}

		async createInstance() {
			this.axios = axios.create({
				baseURL: this.baseUrl,
				headers: {
					"X-UID": this.user.uid,
					common: {
						"Access-Control-Allow-Origin": "*",
						"Access-Control-Allow-Headers": "*",
						"Accept-Language": "*",
						"Content-Type": "application/json",
					},
				},
			});
			this.repositories = createRepository(this.axios);
		}

		injectRepositories() {
			const resourceRepositories = createRepository(this.axios);
			this.repositories = resourceRepositories;
		}

		handleInterceptors() {
			this.axios.interceptors.response.use((response) => {
				if (response.status === 200) {
					// this.handleApiError(response);
					return response;
				} else {
					this.handleApiError(response);
					return null;
				}
			});
		}

		handleApiError(response) {
			console.error("error response", response);
		}

		async init() {
			await this.createInstance();
			this.handleInterceptors();
		}

		getCurrentUser() {
			return this.user;
		}
	}

	return new httpResources();
})();
